import { SubmissionFilterKey } from 'common/enums';

export const SUBMISSIONS_ORDER_BY = {
  // DEFAULT
  DEFAULT: {
    all: '-is_favorite, -submission_ai__weighted_ranking, -updated_at',
    evaluate: '-is_favorite, -submission_ai__weighted_ranking, -updated_at',
    rank: '-is_favorite, -avg_assessment, -submission_ai__weighted_ranking, -updated_at',
    interview:
      '-is_favorite, -is_hired, -avg_assessment, -submission_ai__weighted_ranking, -updated_at',
  },
  // DATE
  DATE_ASC: {
    all: '-is_favorite, -updated_at',
    evaluate: '-is_favorite, -updated_at',
    rank: '-is_favorite, -updated_at',
    interview: '-is_favorite, -updated_at',
  },
  DATE_DESC: {
    all: '-is_favorite, updated_at',
    evaluate: '-is_favorite, updated_at',
    rank: '-is_favorite, updated_at',
    interview: '-is_favorite, updated_at',
  },

  // AI RANK ASC (worst ranked first)
  AI_RANK_ASC: {
    all: '-is_favorite, submission_ai__weighted_ranking, updated_at',
    evaluate: '-is_favorite, submission_ai__weighted_ranking, updated_at',
    rank: '-is_favorite, avg_assessment, submission_ai__weighted_ranking, updated_at',
    interview:
      '-is_favorite, is_hired, avg_assessment, submission_ai__weighted_ranking, updated_at',
  },

  // AI RANK DESC (best ranked first)
  AI_RANK_DESC: {
    all: '-is_favorite, -submission_ai__weighted_ranking, -updated_at',
    evaluate: '-is_favorite, -submission_ai__weighted_ranking, -updated_at',
    rank: '-is_favorite, -avg_assessment, -submission_ai__weighted_ranking, -updated_at',
    interview:
      '-is_favorite, -is_hired, -avg_assessment, -submission_ai__weighted_ranking, -updated_at',
  },
};

export const SUBMISSIONS_FILTERS = [
  {
    key: SubmissionFilterKey.DATE_ASC,
    label: 'sort-by-options.newest',
    value: SUBMISSIONS_ORDER_BY.DATE_ASC,
  },
  {
    key: SubmissionFilterKey.DATE_DESC,
    label: 'sort-by-options.oldest',
    value: SUBMISSIONS_ORDER_BY.DATE_DESC,
  },
  {
    key: SubmissionFilterKey.AI_RANK_ASC,
    label: 'sort-by-options.ai-classified-last',
    value: SUBMISSIONS_ORDER_BY.AI_RANK_ASC,
  },
  {
    key: SubmissionFilterKey.AI_RANK_DESC,
    label: 'sort-by-options.ai-classified-first',
    value: SUBMISSIONS_ORDER_BY.AI_RANK_DESC,
  },
];

export const DEFAULT_FILTER = 3; // AI_RANK_DESC INDEX
